import { ActivityIndicator, View } from "react-native";
import React from "react";
import { useTheme } from "./AHTheme/AHTheme";

export const AHQueryHandlerLoading: React.FunctionComponent = React.memo(() => {
  const theme = useTheme();
  return (
    <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
      <ActivityIndicator color={theme.washedText} size="small" />
    </View>
  );
});
